import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Timer } from '../../../model/myria/app/timer';

@Component({
  selector: 'timer-component',
  templateUrl: 'timer-component.html'
})
export class TimerComponent {
  @Input() time: number;
  @Output() finishTimer = new EventEmitter<any>();
  timer: Timer;

  ngOnInit() {
    this.initTimer();
    setTimeout(() => {
      this.startTimer();
    }, 1000);
  }

  constructor() {}

  initTimer() {
    this.timer = <Timer>{
      seconds: this.time,
      runTimer: false,
      hasStarted: false,
      hasFinished: false,
      secondsRemaining: this.time
    };
    this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);
  }

  startTimer() {
    this.timer.hasStarted = true;
    this.timer.runTimer = true;
    this.timerTick();
  }

  timerTick() {
    setTimeout(() => {
      if (!this.timer.runTimer) {
        return;
      }
      this.timer.secondsRemaining--;
      this.timer.displayTime = this.getSecondsAsDigitalClock(this.timer.secondsRemaining);
      if (this.timer.secondsRemaining > 0) {
        this.timerTick();
      } else {
        this.timer.hasFinished = true;
        this.finishTime();
      }
    }, 1000);
  }

  getSecondsAsDigitalClock(inputSeconds: number) {
    let sec_num = parseInt(inputSeconds.toString(), 10);
    let hours = Math.floor(sec_num / 3600);
    let minutes = Math.floor((sec_num - hours * 3600) / 60);
    let seconds = sec_num - hours * 3600 - minutes * 60;
    let hoursString = '';
    let minutesString = '';
    let secondsString = '';
    hoursString = hours < 10 ? '0' + hours : hours.toString();
    minutesString = minutes < 10 ? '0' + minutes : minutes.toString();
    secondsString = seconds < 10 ? '0' + seconds : seconds.toString();

    return hoursString + ':' + minutesString + ':' + secondsString;
  }

  finishTime() {
    this.finishTimer.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/myria/timer-component/timer-component.ts